<template>
    <div class="video">
		<video :src="video_url" controls  autoplay muted loop width="100%" height="220px" x5-video-player-type='h5' webkit-playsinline="true" playsinline="true">
		</video>
		<div class="video-content">
			<p class="video-name">{{name}}</p>
			<p class="des">{{des}}</p>
			<p v-html="content"></p>
		</div>
		<div class="recommends" v-if="recommends.length>0">
			<p>RECOMMEND</p>
			<p>推荐阅读</p>
			<div v-for="(item,index) in recommends" :key="index">
				<a :href="'/video?id='+item.id" v-if="item.type==3">{{item.name}}</a>
				<a :href="'/exclusiveView/details?article_id='+item.id" v-else>{{item.name}}</a>
			</div>
		</div>
	</div>     
</template>
<script>
import {ArticlesDetails,articleRecommend} from "../../config/interface.js"
// import Player  from '@/components/Meeting/Player'
	export default{
		// components:{
			
		// },
		data(){
			return{
				video_url:'',
                name:'',
				share_img:'',
				des:'',
				writer:{},
				content:'',
				recommends:[]
			}
		},
        created(){
			this.getDetails();
			this.getRecommends();
        },
		computed:{
			id(){
				return this.$route.query.id;
			}

		},
		mounted(){
           
		},
		methods:{
          //文章详情
			getDetails(){
				const url=ArticlesDetails;
				let params={
					article_id:this.id
				};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.video_url=data.bind_url;
						this.name=data.name;
						this.share_img=data.share_pic;
						this.des=data.des;
						this.content=data.content;
						if(data.writers&&data.writers.length){
							this.writer=data.writers[0];
						}
						document.title='观看人次'+data.read;
						if(common.is_weixin()){
							common.wxShare(data.name,data.des,data.share_pic);
						}
					}
				})
			},
			//文章推荐
			getRecommends(){
				const url=articleRecommend;
				let params={
					article_id:this.id
				};
				const method='POST';
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						this.recommends=data;
						
					}
				})
			},
			
		}
	}
</script>
<style lang="scss">
.video{
.video-content{
	margin: 20px;
	.des{
		font-size: 14px;
		letter-spacing: 1px;
		margin-bottom: 10px;
		color: gray;
	}
	p{
		img{
			width:100%;
		}
	}
	.video-name{
		font-size: 16px;
		letter-spacing: 1px;
		margin-bottom: 10px;
		color: black;
	}
}
.recommends{
	margin: 20px;
		p{
			text-align: center;
			font-size: 15px;
			line-height: 0.8rem;
		}
		a{
			text-decoration: underline;
			font-size: 13px;
			line-height: 0.6rem;
			color: darkblue;
		}
	}
}

</style>



// WEBPACK FOOTER //
// src/pages/Region/Video.vue